import React from 'react';

import Fade from '@mui/material/Fade';

import { isFeatureEnabled } from 'ff/common/ffAppUtils';
import TracklogMapControls from 'ff/debrief/components/map/TracklogMapControls';
import ErrorBar from 'ff/debrief/components/ErrorBar';
import InfoSidebar from 'ff/debrief/components/debriefSidebar/InfoSidebar';
import DebriefSidebar from 'ff/debrief/components/debriefSidebar/DebriefSidebar';
import Timeline from 'ff/debrief/components/timeline';
import SegmentDetails from 'ff/debrief/components/scoringDetails/SegmentDetails';
import MapAreaGrid from 'ff/debrief/layouts/MapAreaGrid';
import OwnshipMapLayer from 'ff/debrief/components/map/OwnshipMapLayer';
import { useDebriefApp, useChrono, useRouteContext } from 'ff/debrief/hooks';
import FlightInstrumentsTabs from 'ff/debrief/components/hud/FlightInstrumentsTabs';

export const pathString = '/debrief/track/:shareId';

const SharePageRoute = () => {
    const { isChartOpen } = useDebriefApp();
    const { currentPoint } = useChrono();

    useRouteContext({
        page: 'AnonSharedView',
    });

    return (
        <>
            {isFeatureEnabled('debrief_features') && currentPoint && (
                <OwnshipMapLayer
                    latitude={currentPoint?.latitude}
                    longitude={currentPoint?.longitude}
                    bearing={currentPoint?.bearing}
                />
            )}
            <MapAreaGrid>
                <TracklogMapControls />
                {isFeatureEnabled('debrief_features') ? (
                    <DebriefSidebar />
                ) : (
                    <InfoSidebar />
                )}
                {isFeatureEnabled('debrief_features') && <Timeline />}
                <ErrorBar />
                {isFeatureEnabled('debrief_features') && (
                    <Fade in={isChartOpen} unmountOnExit>
                        <SegmentDetails />
                    </Fade>
                )}
                {(isFeatureEnabled('debrief_hud') ||
                    isFeatureEnabled('debrief_features')) && (
                    <FlightInstrumentsTabs />
                )}
            </MapAreaGrid>
        </>
    );
};

export default SharePageRoute;
